import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompanyAddress from '../_reducers/companyAddress';

export const selectCompanyAddressState =
  createFeatureSelector<fromCompanyAddress.CompanyAddressState>('companyAddresses');

export const selectAllCompanyAddresses = createSelector(
  selectCompanyAddressState,
  fromCompanyAddress.selectAll
);

export const selectCompanyAddressEntities = createSelector(
  selectCompanyAddressState,
  fromCompanyAddress.selectEntities
);

export const selectCompanyAddressById = (id: number) =>
  createSelector(selectCompanyAddressEntities, (entities) => entities[id]);

export const selectCompanyAddressTotal = createSelector(
  selectCompanyAddressState,
  fromCompanyAddress.selectTotal
);
